"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (application) => `
fragment DatePart              on DateMessagePart                                { name date { iso8601 } } 
fragment PlainPart             on BackwardCompatibilityPlainMessagePart          { name plain } 
fragment PlainText             on PlainTextMessagePart                           { name text } 
fragment Link                  on LinkMessagePart                                { name url label authRequired } 
fragment TypographicalEmphasis on RichTextMessagePartMethodTypographicalEmphasis { method name } 
fragment ForegroundColor       on RichTextMessagePartMethodForegroundColor       { colorType name }
fragment RichText              on RichTextMessagePart                            { name methods { __typename ...TypographicalEmphasis ...ForegroundColor } text } 
fragment Metadata              on MessageMetadata                                { type } 

fragment PhotoMedia on PhotoMedia {
  mediaId
  caption
  createdAt {
    iso8601
  }
  sizes {
    large {
        size {
        width
        height
      }
      url
      authRequired
    }
    medium {
        size {
        width
        height
      }
      url
      authRequired
    }
    thumbnail {
      size {
        width
        height
      }
      url
      authRequired
    }
  }
}

query chat ($interlocutor: Int, $after: String, $before: String, $limit: Int!) {
  ${application == "PBP" ? "chat" : "chat: pmpChat"} (interlocutor: $interlocutor, after: $after, before: $before, limit: $limit) {
      id 
      parts {
        __typename
        ...PlainPart 
        ...PlainText 
        ...Link 
        ...RichText 
        ...DatePart
      }
      from {
          id 
          firstName
          lastName
      }
      sent 
      metadata {
        ...Metadata
      }
       attachment {
        __typename
        ...PhotoMedia
      }
  }
}`;
//# sourceMappingURL=chatQueryFactory.js.map